import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Radio, RadioGroup, Slide, Stack, TextField, Typography } from '@mui/material'
import React, { forwardRef, useState } from 'react'
import { getProfile } from '../../reducer/profileSlice';
import { useSelector } from 'react-redux';
import CustomDatePicker from './ComponentReuse/CustomDatePicker';
import { getEOCConfig } from '../../reducer/eocConfigSlice';
import { LoadingButton } from '@mui/lab';
import { getWeekOfYear } from '../../function/WOY';
import ResponseDialog from './ComponentReuse/ResponseDialog';
import dayjs from "dayjs";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function CreateEOCDialog({ open, setOpen, headerLabel, handleSuccess }) {

    const profile = useSelector(getProfile);
    const eocConfig = useSelector(getEOCConfig);
    const [incidentCommander, setIncidentCommander] = useState(null);
    const [isRadioButtonSelected, setIsRadioButtonSelected] = useState(true);
    const [participatingOrg, setParticipatingOrg] = useState(null);
    const [loading, setLoading] = useState(false);
    const [startEOCDate, setStartEOCDate] = useState(null);
    const [status, setStatus] = useState("");
    const [modalResponse, setModalResponse] = useState(false);
    const [value, setValue] = useState(null);

    const handleClose = () => {
        setModalResponse(false);
        setStartEOCDate(null);
        setValue(null);
        setStatus("");
        setParticipatingOrg(null);
        setIsRadioButtonSelected(true);
        setIncidentCommander(null);
        setOpen(false);
    };

    const getEOCDataTitle = () => {
        let data = {
            org_name: "",
            org_name_title: "",
        };
        if (profile?.org_level === "01") {
            data.org_name += profile?.org_name;
            data.org_name_title += "ประเทศ";
        } else if (profile?.org_level === "02") {
            data.org_name += profile?.org_name;
            data.org_name_title += "เขต";
        } else if (profile?.org_level === "03") {
            data.org_name += profile?.province_name;
            data.org_name_title += "จังหวัด";
        } else if (profile?.org_level === "04") {
            data.org_name +=
                profile?.amphur_name + " จังหวัด" + profile?.province_name;
            data.org_name_title += "อำเภอ";
        }
        return data;
    };

    const handleRadioChange = (event) => {
        const { name, value } = event.target;
        if (
            value === eocConfig?.config?.incident_commander[profile?.org_level]?.ic[eocConfig?.config?.incident_commander[profile?.org_level]?.ic.length - 1].ic_name
        ) {
            setIsRadioButtonSelected(false);
        } else {
            setIsRadioButtonSelected(true);
        }
        setIncidentCommander({
            ic_id: name,
            ic_name: value,
        });
    };

    const handleTextValue = (e) => {
        const { name, value } = e.target;
        setIncidentCommander({
            ic_id: name,
            ic_name: value,
        });
    };

    const handleCheckboxChange = (e) => {
        const checkboxId = e.target.value;
        const checkboxName = e.target.name;
        let newParticipatingOrg = participatingOrg? {...participatingOrg}: {};
        if (e.target.checked) {
            newParticipatingOrg[checkboxId] = checkboxName;
        } else {
            delete newParticipatingOrg[checkboxId];
        }
        setParticipatingOrg(newParticipatingOrg);
    };

    const handleCloseResponse = () => {
        setModalResponse(false);
        if (incidentCommander && participatingOrg && startEOCDate) {
            handleSuccess();
            setOpen(false);
        }
    };

    const handleSubmit = async () => {
        try {
            setLoading(true);
            if (incidentCommander && participatingOrg && startEOCDate) {
                let participating_org = [];
                for (const key in participatingOrg) {
                    if (Object.hasOwnProperty.call(participatingOrg, key)) {
                        participating_org.push({
                            po_type_id: key,
                            po_type_name: participatingOrg[key],
                        });
                    }
                }
                participating_org.sort((a, b) => {
                    return a.po_type_id.localeCompare(b.po_type_id);
                });

                let dataSend = {
                    ...startEOCDate,
                    incident_commander: { ...incidentCommander },
                    participating_org: participating_org,
                    creator_id: profile?.inum,
                    creator_name: profile?.displayName,
                    province_code: profile?.province_code,
                    province_name: profile?.province_name,
                    amphur_code: profile?.amphur_code,
                    amphur_name: profile?.amphur_name,
                    tambon_code: profile?.tambon_code,
                    tambon_name: profile?.tambon_name,
                    area_code: profile?.area_code,
                    org_id: profile?.org_id,
                    org_name: profile?.org_name,
                    org_type: profile?.org_type,
                    org_type_name: profile?.org_type_name,
                    org_level: profile?.org_level,
                    org_level_name: profile?.org_level_name,
                    phone: profile?.telephone,
                    email: profile?.mail,
                };

                const response = await fetch(`${process.env.REACT_APP_API_URL}/my_eoc/create_eoc`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(dataSend),
                });
                if (!response.ok) {
                    setStatus("ไม่สามารถเปิด EOC ได้");
                    setModalResponse(true);
                }

            } else {
                let request = "ใส่ข้อมูล";
                if (incidentCommander) {
                    request += " ผู้บัญชาการเหตุการณ์";
                }
                if (participatingOrg) {
                    request += " หน่วยงานที่มีส่วนร่วม";
                }
                if (startEOCDate) {
                    request += " วันที่";
                }
                setStatus((request += "ไม่ครบ"));
                setModalResponse(true);
            }
            setLoading(false);
        } catch (error) {
            console.log(error);
        }
    };

    const handleDate = (value) => {
        let woy = getWeekOfYear(value.toDate());
        setStartEOCDate({
            start_eoc_timestamp: value.valueOf().toString(),
            start_eoc_week: woy.week,
            start_eoc_year: woy.year,
        });
        setValue(value);
    };

    return (
        <Dialog
            fullWidth={true}
            maxWidth={'lg'}
            open={open}
            TransitionComponent={Transition}
        >
            <DialogContent className='p-4 md:p-8 max-w-7xl w-full overflow-auto' dividers>
                <div className='mb-8'>
                    <Typography variant="h6" component="div">
                        {headerLabel}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                        ท่านกำลังเปิด EOC กรุณาป้อนข้อมูลดังนี้
                    </Typography>
                </div>
                <div className='mx-auto grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-y-8'>
                    <div>
                        <Typography variant="subtitle2" sx={{ color: "#D48061" }}>
                            {getEOCDataTitle().org_name_title}
                        </Typography>
                        <Typography variant="body1">
                            {getEOCDataTitle().org_name}
                        </Typography>
                        <div className='mt-8'>
                            <Typography variant="subtitle2" className='text-[#D48061]'>วันที่เปิด EOC</Typography>
                            <CustomDatePicker
                                className='max-w-[300px]'
                                minDate={dayjs().add(-7, 'day')}
                                value={value}
                                onChange={handleDate}
                                slotProps={{
                                    textField: { size: 'small', inputProps: { value: value ? `${value.format('DD/MM/BBBB')}` : '' } },
                                }}
                            />
                            <FormControl>
                                <Typography variant="subtitle2" className='text-[#D48061] mt-8'>ผู้บัญชาการเหตุการณ์</Typography>
                                <RadioGroup
                                    onChange={handleRadioChange}
                                    aria-labelledby="demo-radio-buttons-group-label"
                                    name="radio-buttons-group"
                                >
                                    {eocConfig?.config.incident_commander[
                                        profile?.org_level
                                    ]?.ic.map((data, index) => {
                                        return (
                                            <div key={index}>
                                                <FormControlLabel
                                                    value={data.ic_name}
                                                    control={
                                                        <Radio
                                                            sx={{
                                                                "&.Mui-checked": {
                                                                    color: "#D48061",
                                                                },
                                                            }}
                                                        />
                                                    }
                                                    name={data.ic_id}
                                                    label={data.ic_name}
                                                />
                                                {data.ic_name ===
                                                    eocConfig?.config?.incident_commander[
                                                        profile?.org_level
                                                    ]?.ic[
                                                        eocConfig?.config?.incident_commander[
                                                            profile?.org_level
                                                        ]?.ic.length - 1
                                                    ].ic_name && (
                                                        <TextField
                                                            size="small"
                                                            name={data.ic_id}
                                                            onChange={handleTextValue}
                                                            disabled={isRadioButtonSelected}
                                                        />
                                                    )}
                                            </div>
                                        );
                                    })}
                                </RadioGroup>
                            </FormControl>
                        </div>
                    </div>
                    <div>
                        <div style={{ flex: 1 }}>
                            <Typography variant="subtitle2" sx={{ color: "#D48061", mb: 1 }}>ประเภทหน่วยงานที่มีส่วนร่วม</Typography>
                            <div className="w-full grid gap-3 grid-cols-1">
                                {eocConfig?.config.participating_org_type.map((data, index) => {
                                    return (
                                        <Stack
                                            key={index}
                                            direction='row'
                                            sx={{
                                                backgroundColor: participatingOrg && participatingOrg[data.po_type_id] !== undefined ? "rgb(253, 248, 246)" : "white",
                                                border: participatingOrg && participatingOrg[data.po_type_id] !== undefined ? '1px solid #cd6c4a' : '1px solid #ccc',
                                            }}
                                            className='rounded px-2 py-3'
                                        >
                                            <Checkbox
                                                value={data.po_type_id}
                                                name={data.po_type_name}
                                                onChange={handleCheckboxChange}
                                            />
                                            <Typography variant="body1">
                                                {data.po_type_name}
                                                <br />
                                                <span style={{ color: 'rgba(0,0,0,0.6)', fontSize: '0.875rem' }}>
                                                    เช่น {data.example.toString().replaceAll(",", " ")}
                                                </span>
                                            </Typography>
                                        </Stack>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </DialogContent>
            <DialogActions className='mx-2 md:mx-6 gap-2 my-1'>
                <LoadingButton
                    loading={loading}
                    variant="contained"
                    className='bg-[#cd6c4a] hover:bg-[#cd6c4a] w-28'
                    disabled={!incidentCommander || !participatingOrg || !startEOCDate}
                    onClick={handleSubmit}
                >เปิด EOC</LoadingButton>
                <Button
                    disabled={loading}
                    variant="outlined"
                    className='w-28'
                    color='inherit'
                    onClick={handleClose}
                >ยกเลิก</Button>
            </DialogActions>
            <ResponseDialog
                open={modalResponse}
                onClose={handleCloseResponse}
                dataResponse={status}
            />
        </Dialog>
    )
}

export default CreateEOCDialog